import { defer, LoaderFunction } from 'react-router-dom'

import { PaginatedResponse } from '@custom-types/response'
import { WithRequired } from '@custom-types/utils'
import Product from '@models/Product'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type PurchasedScoresResponse = {
  scores: WithRequired<Product, 'audio_preview_url'>[]
} & PaginatedResponse

export type PurchasedLoaderResponse = {
  purchasedScores: Promise<PurchasedScoresResponse>
  order: string | null
}

export const PURCHASED_PAGE_SIZE = 15

const purchasedScoresLoader: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url)

  const order = url.searchParams.get('order')
  const purchasedScores = http.loader.post(ApiRoutes.members.purchasedScoresPath(), {
    order,
    max_count: PURCHASED_PAGE_SIZE,
  })
  return defer({ purchasedScores, order })
}

export default purchasedScoresLoader
